export default "__VITE_ASSET__f3b29050__"